<template>
  <div class="Lookahead_child container-fluid">
    <div class="row">
        <div class="col mainBar">
          <div >
            <div v-bind:toolSelection="selected">
              <div class="col topText">
                <div class="title">
                  {{tool[0].title}}
                </div>
                 <div class="techUsed">
                  {{tool[0].techUsed}}
                </div>
              <div class="row">
              <div class="col-6">
                <div class="screenshots">
                  <img :src="tool[0].image1">
                </div>
              </div>
              <div class="col-6">
                <div class="screenshots">
                  <img :src="tool[0].image2">
                </div>
              </div>
            </div>

                <div class="content">
                  {{tool[0].content}}
                </div>
              </div>
            </div>
          </div> 

          <div>

            <div class="row">
              <div class="col">
                <div class="issues">
                  <b>Source Code:</b> <span style="font-style:italic"> {{tool[0].sourceCodeAvailability}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
    
    </div>
  </div>
</template>

<script>
export default {
  name: 'Lookahead_child',
  data:() =>({
    tool: [{
      title: "Lookahead jira",
      techUsed: "Python3.7, vuejs (framework), vuejs-datepicker (calendar), electron (app library), moment (manipulate and display dates), excel4node, jira-client , Virtualenv (encapsulation of dependencies)",
      content: "This tool has two functions, one is to extract information from tasks and the other scans the history to analyze its content for various operations.\n\n"+
      "The retrieval feature helped integrators get essential information from our weekly tasks in the Jira program. This information was then saved to an Excel file."+ 
      "A color code has been put in place to highlight the missing information.\n\nThe history scanning feature helps our CRM team assess last-minute tasks created by members"+
      " of our external team. This tool analyzes the history of each Jira task and collects information about when and how the task was moved during the week.\n\n\n"+
      "Cet outil a deux fonctions, l'une est d'extraire les informations des tâches et l'autre analyse l'historique pour ensuite faire diverses opérations sur celles-ci. \n\nLa fonction"+
      " de récupération est utile pour les intégrateurs à extraire les informations essentielles de nos tâches hebdomadaires du programme Jira. Ces informations sont"+
      " ensuite enregistrées dans un fichier Excel. Un code couleur est mis en place pour mettre en évidence les informations manquantes.  \n\nLa fonction d'analyse de"+
      " l'historique aide notre équipe CRM à évaluer les tâches de dernière minute créées par les membres de notre équipe externe. Cet outil analyse l'historique de chaque"+
      " tâche Jira et collecte des informations sur le moment et la façon dont la tâche a été déplacée au cours de la semaine choisie.",
      sourceCodeAvailability: "Unavailable, proprietary code",
      image1: require("@/assets/tools/Lookahead/GUI_localizatino.png"),
      image2: require("@/assets/tools/Lookahead/GUI_localizatino_v1.png")
    }]
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Leckerli+One&display=swap');

.Lookahead_child{
  font-family: 'Roboto', sans-serif;
  max-width: 700px;
  white-space:pre-wrap;
}
.topText{
  display: block;
}
.title{
  font-family: 'Leckerli One', cursive;
  text-align:center;
  font-weight: 700;
  font-size: 1.5em;
  margin-bottom: 2%;
}
.techUsed{
  font-style: italic;
  font-weight: 100;
  font-size: 0.7em;
  text-align: justify;
  margin-bottom: 3%;
}
.content{
  text-align: justify;
  margin-bottom: 4%;
  text-align: justify;
  font-size: 0.9em;
}
.screenshots{
  text-align:center;
  margin-left: 1%;
  margin-right: 1%;
  padding-bottom: 3%;
  height: auto;
}

.issues{
  text-align: center;
  font-size: 0.7em;
}
img{
  width:100%;
  height: 100%;
}
</style>
